import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import Logo from './Logo';

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(135deg, #000000 0%, #0a0a0a 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}
    >
      {/* Animated background elements */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 80%, rgba(0, 255, 0, 0.03) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(0, 255, 0, 0.03) 0%, transparent 50%),
            radial-gradient(circle at 40% 40%, rgba(0, 255, 0, 0.02) 0%, transparent 50%)
          `,
          animation: 'float 20s ease-in-out infinite',
          zIndex: 0,
        }}
      />
      
      {/* Logo */}
      <Box sx={{ mb: 4, zIndex: 1 }}>
        <Logo />
      </Box>
      
      {/* Loading spinner */}
      <CircularProgress
        size={40}
        sx={{
          color: '#00ff00',
          mb: 2,
          zIndex: 1
        }}
      />
      
      {/* Loading text */}
      <Typography
        variant="h6"
        sx={{
          color: '#00ff00',
          fontFamily: 'monospace',
          textAlign: 'center',
          zIndex: 1
        }}
      >
        Loading MEME FR...
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
